import { countryWiseDownload } from "assets/data/dashboard";
import { CustomComponentProps } from "utils/types/general.types";
import { playstore, web } from "utils/assets_exports/images";
import { SVG } from "ui";

export type CountryCardProps = CustomComponentProps & {
    country: countryWiseDownload;
};

const CountryCard = ({ country, className, style }: CountryCardProps) => {
    return (
        <div
            className={`country-card text-sm w-full px-2 flex justify-between items-center gap-5 flex-wrap dark:text-white ${className}`}
            style={style}
        >
            <p className="text-wrap">{country.country}</p>
            <div
                className="flex justify-center items-center gap-1"
                style={{ width: "40%" }}
            >
                <span>{country.count}</span>
                <SVG svg="apple" size={14} className="cursor-default" />
                <span>/</span>
                <span>{country.count}</span>
                <img
                    src={playstore}
                    alt="play store"
                    style={{ width: 14, height: 14 }}
                />
                <span>/</span>
                <span>{country.count}</span>
                <img
                    src={web}
                    alt="play store"
                    style={{ width: 14, height: 14 }}
                />
            </div>
        </div>
    );
};

export default CountryCard;
